import styled, { css } from 'styled-components';
import background from './svgs/GrassyBackground.svg';
import popupBackground from './svgs/PopupBackground.svg';
import lecturaIcon from './svgs/LecturaIcon.svg';
import readingIcon from './svgs/ReadingIcon.svg';
import bannerBackground from './svgs/Banner.svg';
import BtnLowProfile from '../components/Buttons/BtnLowProfile';

export const Container = styled.div`
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  overflow: hidden;
  align-items: center;
  width: 1024px;
  height: 576px;
  background-image: url(${background});
`;

export const Banner = styled.div`
  position: absolute;
  width: 373px;
  height: 182px;
  left: 326px;
  top: 10px;
  background-image: url(${bannerBackground});
`;

export const PopupBackground = styled.div`
  position: relative;
  padding: 70px 30px;
  height: 373px;
  width: 589px;
  top: 144px;
  left: 218px;
  background-image: url(${popupBackground});
`;

export const LecturaButton = styled.button`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 145px;
  min-height: 185px;
  border-radius: 30px;
  cursor: pointer;
  border: 6px solid ${({ selected }) => (selected ? '#7365FF' : 'transparent')};
  background: #ffffff;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.2));
`;

export const ReadingButton = styled(LecturaButton)``;

export const LecturaIcon = styled.div`
  position: absolute;
  top: -6px;
  left: 3px;
  width: 162px;
  height: 127px;
  background-image: url(${lecturaIcon});
`;

export const ContinueButton = styled(BtnLowProfile)`
  position: absolute;
  padding: 0;
  top: 330px;
  left: 200px;
  width: 190px;
  height: 84px;
  font-size: 40px;
  line-height: normal;
  span {
    --icon-spacing: 8px;
    --icon-boxSize: 40px;
  }
  ${({ isLecturaSelected }) =>
    isLecturaSelected &&
    css`
      left: 161px;
      width: 281px;
    `}
`;

export const IconWrapper = styled.div`
  position: relative;
  height: 110px;
  width: 100%;
`;

export const ReadingIcon = styled.div`
  position: absolute;
  top: -5px;
  left: 25px;
  width: 138px;
  height: 109px;
  background-image: url(${readingIcon});
`;

export const Label = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  position: relative;
  transform: translate(-50%, 0);
  left: 50%;
  bottom: -6px;
  padding: 5px 0;
  width: calc(100% + 12px);
  font-family: Quicksand Medium;
  font-size: 24px;
  line-height: 28px;
  color: white;
  text-shadow: 0px -1px 0px #cbdfee;
  text-align: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 0px 0px 30px 30px;
  border-style: solid;
  border-color: ${({ selected }) => (selected ? '#7365FF' : '#CBDFEE')};
  border-width: ${({ selected }) => (selected ? '0px 6px 6px 6px' : ' 0px 2px 6px 2px')};
`;

export const UsageTime = styled.span`
  font-size: 21px;
  font-family: Quicksand;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 95px;
  width: 100%;
  height: 100%;
`;
